import { z } from 'zod';

/**
 * AI response schemas — raw JSON shapes returned by LLM providers.
 * These are parsed by worker step-functions after calling llm.complete().
 * They are NOT the same as output schemas stored in ai_steps (see ai-step-outputs.ts).
 */

// ─── Step1Describe AI response ────────────────────────────────────────────────

export const Step1DescribeAiResponse = z.object({
  main_subject: z.string().min(1),
  style: z.enum(['zdjęcie', 'ilustracja', 'grafika', 'niepewne']).catch('niepewne'),
  mood: z
    .enum(['spokojny', 'neutralny', 'dynamiczny', 'tajemniczy', 'surowy'])
    .catch('neutralny'),
  palette: z.enum(['stonowana', 'żywa', 'neutralna']).catch('neutralna'),
  brightness: z.enum(['jasna', 'ciemna', 'mieszana']).catch('mieszana'),
  dominant_colors: z.string().catch('niepewne'),
  details: z.array(z.string()).catch([]),
  small_details: z.array(z.string()).catch([]),
  opis: z.string().min(1),
});

export type Step1DescribeAiResponse = z.infer<typeof Step1DescribeAiResponse>;

// ─── Step2Seo AI response ─────────────────────────────────────────────────────

export const Step2SeoAiResponse = z.object({
  listing_name: z.string(),
  listing_alt: z.string(),
  seoText: z.string(),
  h1: z.string(),
  title: z.string(),
  metaDescription: z.string(),
});

export type Step2SeoAiResponse = z.infer<typeof Step2SeoAiResponse>;

// ─── CategoryMeta AI response ─────────────────────────────────────────────────

export const CategoryMetaAiResponse = z.object({
  h1: z.string(),
  title: z.string(),
  metaDescription: z.string(),
  seoTextHtml: z.string(),
  faq: z.array(z.object({ question: z.string(), answer: z.string() })).optional(),
});

export type CategoryMetaAiResponse = z.infer<typeof CategoryMetaAiResponse>;
